<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    盐田港西站<br>
站点介绍<br>
盐田港西站位于深圳市盐田区梧桐路与下梧桐路之间的深盐路下方，车站沿深盐路西南至东北方向布置。东北接深外高中站，西南接海山站。 盐田港西站定义为特色站，以“港口码头”提取港口集装箱作为设计元素，通过集装箱的组合与艺术灯具进行整合设计。为地下两层车站，地下一层为站厅层，地下两层为站台层，站台形式为岛式站台。车站设置有4个出入口，临近黄金珠宝大厦、威明电子有限公司工业大楼、周大福集团大厦，周边为成熟配套工业区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:16	8号线	5分10秒	5分45秒<br>
盐田路	06:46	00:25	8号线	5分10秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:05	23:15	8号线	4分钟	5分钟<br>
盐田路	06:46	00:25	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:05	00:05	8号线	4分钟	5分钟<br>
盐田路	06:46	01:25	8号线	4分钟	5分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
深盐路南侧（西）、深圳盐田综合保税区沙头角片区、海山街道保税区文化活动中心<br><br>
A2出入口:<br>
深盐路南侧（东）、深圳盐田天主之母堂<br><br>
B1出入口:<br>
盐田海事局、海景二路东侧（南）、协和路<br><br>
B2出入口:<br>
盐田海事局、海景二路东侧（南）、协和路<br><br>
C出入口:<br>
深圳是公安局盐田分局、深圳广播电视大学沙头角分校、中共深圳市盐田区委党校、深盐路北侧（西）<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 盐田港西地铁站①<br>
308、M191、M196（原B961）、M199、M437、M520、M205、M314<br><br>
B2出入口:<br>
公交站名： 周大福大厦<br>
M199、M205、M362、M437、M444、M520、高峰专线103、68、308、B924、B982、M196（原B961）、M191<br><br>
B2出入口:<br>
公交站名： 盐田港西地铁站<br>
大梅沙假日专线1号（周末节假日运营）<br><br>
C出入口:<br>
公交站名： 盐田港西地铁站①<br>
308、M191、M196（原B961）、M199、M437、M520、M205、M314<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>